/**
 * Metabolae Timeline Scroll Progress Bar
 * Fills the vertical line to the center of each dot as it passes viewport center.
 * Progress is pixel-accurate: maps dot positions inside .ml-tl to fill height.
 */

(function () {
  'use strict';

  function initTimelineProgress() {
    const timeline = document.querySelector('.ml-tl.wbw-timeline');
    if (!timeline) return;

    const steps = Array.from(timeline.querySelectorAll('.ml-tl-step'));
    if (steps.length === 0) return;

    // The line runs from top: 18px to bottom: 18px inside .ml-tl
    // Each dot center Y (relative to .ml-tl top) = step.offsetTop + 8 (dot top) + 10 (radius) = step.offsetTop + 18
    // Total line length = timeline.offsetHeight - 36 (18px each end)

    function getDotCenterY(step) {
      // offsetTop is relative to offsetParent; walk up to timeline
      let el = step;
      let y = 8 + 10; // dot top offset + radius
      while (el && el !== timeline) {
        y += el.offsetTop;
        el = el.offsetParent;
      }
      return y;
    }

    function updateProgressBar() {
      const viewportCenter = window.innerHeight / 2;
      const tlRect = timeline.getBoundingClientRect();
      const lineStart = 18; // top: 18px in CSS
      const lineEnd = timeline.offsetHeight - 18; // bottom: 18px in CSS
      const lineLength = lineEnd - lineStart;

      if (lineLength <= 0) return;

      let fillPx = 0;
      let lastActiveDotY = null;

      steps.forEach((step) => {
        const stepRect = step.getBoundingClientRect();
        const dotViewportY = stepRect.top + 8 + 10; // dot center in viewport coords
        const isActive = dotViewportY < viewportCenter;

        if (isActive) {
          step.setAttribute('data-active', 'true');
          lastActiveDotY = getDotCenterY(step); // relative to timeline top
        } else {
          step.removeAttribute('data-active');
        }
      });

      if (lastActiveDotY !== null) {
        // Find index of last active step (compat: avoid findLastIndex)
        let activeIdx = -1;
        for (let i = steps.length - 1; i >= 0; i--) {
          if (steps[i].dataset.active === 'true') { activeIdx = i; break; }
        }
        const nextStep = activeIdx >= 0 && activeIdx < steps.length - 1 ? steps[activeIdx + 1] : null;

        if (nextStep) {
          const nextDotViewportY = nextStep.getBoundingClientRect().top + 8 + 10;
          const lastDotViewportY = steps[activeIdx].getBoundingClientRect().top + 8 + 10;
          // Interpolate between last active dot and next dot based on viewport center
          const range = nextDotViewportY - lastDotViewportY;
          const traveled = viewportCenter - lastDotViewportY;
          const t = range > 0 ? Math.max(0, Math.min(1, traveled / range)) : 0;

          const lastDotY = getDotCenterY(steps[activeIdx]);
          const nextDotY = getDotCenterY(nextStep);
          fillPx = lastDotY + t * (nextDotY - lastDotY);
        } else {
          // Last dot is active — fill the entire line to the bottom
          fillPx = lineEnd;
        }
      }

      // Clamp to line bounds and convert to 0–1 fraction of line length
      const clampedFill = Math.max(0, Math.min(lineEnd, fillPx));
      const progress = lineLength > 0 ? (clampedFill - lineStart) / lineLength : 0;

      timeline.style.setProperty('--timeline-progress', Math.max(0, Math.min(1, progress)).toString());
    }

    window.addEventListener('scroll', updateProgressBar, { passive: true });
    window.addEventListener('resize', updateProgressBar, { passive: true });
    updateProgressBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTimelineProgress);
  } else {
    initTimelineProgress();
  }

  if (window.MutationObserver) {
    const observer = new MutationObserver(() => {
      const timeline = document.querySelector('.ml-tl.wbw-timeline');
      if (timeline && !timeline.dataset.observing) {
        timeline.dataset.observing = 'true';
        initTimelineProgress();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
